import React from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import MaterialIcon from '../../../components/MaterialIcon';

const ClimateHeader = ({ res, state, stations, onImport, onStationChange, onIntervalChange }) => (
    <header className="weather-header">
        <h1>{res.CLIMA}</h1>
        <div className="weather-header-controls">
            <input accept=".zip" className="weather-hidden-input" id="weather-import" type="file" onChange={onImport} />
            <label htmlFor="weather-import">
                <Button component="span" className="weather-action" title={res.IMPORTAR_BANCO_DADOS}>
                    <MaterialIcon icon="file_upload" />
                </Button>
            </label>
            <FormControl className="weather-station-select">
                <InputLabel>{res.ESTACAO}</InputLabel>
                <Select value={state.idStationSelected || ''} onChange={event => onStationChange(event.target.value)}>
                    {!state.idStationSelected && <MenuItem value="" disabled>{res.CARREGANDO_ESTACOES}</MenuItem>}
                    {stations.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="weather-interval">
                <InputLabel>{res.ATUALIZACAO}</InputLabel>
                <Select value={state.refreshInterval / 60000} onChange={onIntervalChange}>
                    {[1, 3, 5, 10, 15].map(minutes => <MenuItem key={minutes} value={minutes}>{minutes} {res.MIN}</MenuItem>)}
                </Select>
            </FormControl>
        </div>
    </header>
);

export default ClimateHeader;
